import React from 'react';
import PropTypes from 'prop-types';

const CollapseIcon = ({color = '#B1BAC2', width = 'auto', height = 'auto', className = ''}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 32 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>collapse-30px</title>
    <g>
      <g fill={color} fillRule="nonzero">
        <polygon
          id="Path"
          points="16 0 0 16.0018809 3.96285412 19.9628541 16 7.92758905 28.0390267 19.9628541 32 16.0018809"
        />
      </g>
    </g>
  </svg>
);

CollapseIcon.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,

  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * Icon width
   */
  width: PropTypes.string,

  /**
   * Icon height
   */
  height: PropTypes.string,
};
export default CollapseIcon;
